import { render, staticRenderFns } from "./Deflection.vue?vue&type=template&id=3413a824&scoped=true&"
import script from "./Deflection.vue?vue&type=script&lang=js&"
export * from "./Deflection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3413a824",
  null
  
)

export default component.exports